﻿import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Position, Tooltip } from "@blueprintjs/core";
import './Status.css';
import classNames from 'classnames';
import { ShowHide } from 'components/layout';
import './EmployeeCircleStatus.css';
import './StatusPanel.css';

export function EmployeeCircleStatus(
    {
        background = '',
        status = '',
        iconClass = '',
        tooltip = '',
        loading = false,
        small = false,
        isRoaming = false,
        isAgency = false
    }
) {
    const [backgroundColor, setBackgroundColor] = useState('00C6B2');
    const [roamingClassName, setRoamingClassName] = useState('roaming-active');
    const [roamingImage, setRoamingImage] = useState('/images/Core_Roaming_Driver.svg');

    useEffect(() => {
        let newBackgroundColor = '00C6B2';

        if (background) {
            newBackgroundColor = background;
        } else if (status?.toLowerCase() === 'away' || status?.toLowerCase() === 'vehicle off road') {
            newBackgroundColor = 'FF7454';
            setRoamingClassName('roaming-away');
        } else if (status?.toLowerCase() === 'inactive') {
            newBackgroundColor = 'EC2D6D';
            setRoamingClassName('roaming-inactive');
        }

        setBackgroundColor(newBackgroundColor);

        if (isAgency) {
            setRoamingImage('/images/Agency_Roaming_Driver.svg');
        }

        if (isRoaming) {
            setBackgroundColor('FFFFFF');
        }
        
    }, [background, status]);

    return (
        <Tooltip position={Position.TOP} content={tooltip}>
            <div style={{ backgroundColor: isAgency && !isRoaming ? 'transparent' : `#${backgroundColor}`, borderColor: `#${backgroundColor}` }} className={classNames({ "bp6-skeleton": loading }, { "hollow": isAgency && !isRoaming }, "circle-status", "inline-items")}>
                <ShowHide
                    evaluator={!!iconClass && !isRoaming}
                    show={<i className={iconClass}/>}
                />
                <ShowHide
                    evaluator={isRoaming}
                    show={<img alt="tbd" className={roamingClassName} src={roamingImage} />}
                />
                
            </div>
        </Tooltip>
    );
}

EmployeeCircleStatus.propTypes = {
    background: PropTypes.string,
    status: PropTypes.string,
    iconClass: PropTypes.string,
    tooltip: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    loading: PropTypes.bool,
    small: PropTypes.bool,
    isRoaming: PropTypes.bool,
    isAgency: PropTypes.bool
};